import React, { useState, useEffect, memo } from "react";

import Web3Intraction from "utils/web3Intraction";
import useMetaMask from "hooks/metsmask";
import { useSelector, useDispatch } from "react-redux";
import toastr from "toastr";
import { converCryptoToDollar } from "helpers/constants";
import {
  addParticularOwner,
  addPrintRequest,
  addPrintTranasction,
  addTransaction, getArtNotificationsRequest, postNotificationRequest, updateSellItem,

} from "store/actions";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { Link, useFetcher, useNavigate, useSearchParams } from "react-router-dom";
import { Input } from "reactstrap";
import NFTPurchasecenter from "Pages/NFTPurchase/NFTPurchasecenter";


export default memo(function BuyNft(props) {
  // const {}
  const taxPercent = process.env.REACT_APP_PINTER_TAX_PERCENT
  const adminPercent = process.env.REACT_APP_ADMIN_PRINT_PERCENT
  const artistPercent = process.env.REACT_APP_ARTIST_PRINT_PERCENT
  const printerPercent = process.env.REACT_APP_PINTER_PRINT_PERCENT
  const navigate = useNavigate();
  const data = props;
  const { buyType, printInfo, ownerPriceMatic, printerChargeMatic } = data
  const wallAddress = localStorage.getItem("walletAddress");
  const [usdPrice, setUsdPrice] = useState(0);
  const [maticmainnet, setMaticmainnet] = useState(false);
  const [discount, setDiscount] = useState(false);
  const [checkdiscount, setCheckdiscount] = useState(false);
  const { user, settings } = useSelector((state) => state?.Login);

  const dispatch = useDispatch();
  const hooks = useMetaMask();
  const [copies, setCopies] = useState('')
 
  const [checekdValue, setCheckedValue] = useState(false)
  const addPrintCallback = (res) => {
    if (res.status === "success") {
      let printTransData = {};
      printTransData.print_request_id = res.data._id
      printTransData.admin_earning = calPercentAmt(adminPercent, printInfo?.print_charge)
      printTransData.seller_earning = calPercentAmt(artistPercent, printInfo?.print_charge)
      printTransData.printer_earning = calPercentAmt(printerPercent, printInfo?.print_charge)
      printTransData.total_amount = Number(printInfo?.print_charge) + Number(data.saledata?.premium_print_cost || 0)
      printTransData.premium_amount = data.saledata?.premium_print_cost
      printTransData.payment_status = "Completed"
      printTransData.status = "Completed"
      printTransData.nft_id = data?.saledata?.nftid
      printTransData.from = data?.saledata?.owneraddress
      printTransData.to = wallAddress
      printTransData.user_id = user?._id
      printTransData.seller_id = props.ownerId
      printTransData.buyer_id = user?._id
      printTransData.total_price_matic=props?.totalPriceMatic
      dispatch(addPrintTranasction(printTransData))
    } else {
      toastr.error("Error in Print Request")
    }
  }
  const CloseDialog = () => {
    props.fucn()
  }
  const [sellItemId, setSellItemId] = useState()
  const getcopies = (e) => {
    const value = e.target.value.replace(/[^\d]/, '');

    if (value > 0) {
      setCopies(Number(value))

    } else {
      setCopies('')
    }
  }
  const [sellnftFunc, setSellnftFunc] = useState(false)
  const [bidProgress, setBidProgress] = useState(false)

  useEffect(() => {
    setSellItemId(data?.saledata?.sell_id)
    if (user?.referral_count > 0) {
      setCheckdiscount(true);
    }
  }, [data])
  const formatDate = (date) =>
    date ? moment(date).utcOffset(330).format("DD MMM YYYY hh:mm A") : "---";

  const formatDateAddDays = (date) =>
    date
      ? moment(date).add(7, 'days').utcOffset(330).format("DD MMM YYYY hh:mm A")
      : "---";
  console.log("fasdafsdfasdfa", data)
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const calPrice = async () => {
        let amount = 1;
        let symbol = "MATIC";
        let data = await converCryptoToDollar(amount, symbol);
        setUsdPrice((pre) => ({
          ...pre,
          data,
        }));
      };
      calPrice({ price: 1 });
    }, 300);
    return () => clearTimeout(delayDebounceFn);
  }, [copies, data]);

  // set prices
  var [totalPrice, setTotalPrice] = useState(0)
  useEffect(() => {
    if (buyType === "Physical" || buyType === "Digital+Physical") {
      var premiumData = 0;
      var printCharge = 0;
      var usdData = 0
      var tax = 0;
      printCharge = Number(printInfo?.print_charge)
      premiumData = data.saledata?.premium_print_cost ? Number(data.saledata?.premium_print_cost) : 0
      usdData = Number(usdPrice?.data)
      tax = Number(printInfo?.tax)
      setTotalPrice(premiumData + (printCharge / usdData) + tax)
    }
  }, [printInfo, buyType, data.saledata?.premium_print_cost, usdPrice])

  const sellnft = async () => {
    let hasError = false; // Flag to track errors
    if (props.ownerId === user?._id) { return toastr.error("You can not buy your own Digital Artworks") }
    try {
      const web3Interaction = new Web3Intraction("polygon", hooks?.walletType, settings);

      if (!web3Interaction.isNetworkServiceWorking()) {
        toastr.error("Service Not Available!");
        hasError = true;
        return;
      }

      const isMatic = await web3Interaction.ismatic();
      if (!isMatic) {
        setMaticmainnet(true);
        hasError = true;
        return;
      }
      setMaticmainnet(false);

      if (buyType === "Physical") {
        let calamount_cal = 0;
        if (Number(ownerPriceMatic) > 0) {
          calamount_cal = Number(printInfo?.total_cost_matic) - Number(ownerPriceMatic);
        }
        const physicalData = {
          owner: data?.saledata?.owneraddress,
          totalAmount: Number(Number(printInfo?.total_cost_matic).toFixed(5)),
          physicalOwnerAmount: Number(Number(ownerPriceMatic).toFixed(5)),
          calamount: Number(calamount_cal.toFixed(5))

        };

        setBidProgress(true);

        try {
          const res = await web3Interaction.buyPhysicalNFT(wallAddress, physicalData);
          if (res.status) {
            const printRequestData = {
              ...printInfo,
              admin_earning: calPercentAmt(adminPercent, printInfo?.printer_alone_charge),
              printer_earning: printInfo?.printer_alone_charge,
              seller_earning: calPercentAmt(artistPercent, printInfo?.printer_alone_charge),
              order_received_date: formatDate(new Date()),
              due_date: formatDateAddDays(new Date()),
              owner_id: props.ownerId
            };

            dispatch(addPrintRequest(printRequestData, addPrintCallback));
            toastr.success("Print request added successfully");
          } else {
            toastr.error("Something went wrong during the physical Digital Artwork purchase.");
            hasError = true;
          }
        } catch (err) {
          console.log("thisistheerrror", err)
          toastr.error(err.message || "An error occurred.");
          hasError = true;
        }
      } else if (buyType === "Digital") {
        const discountAmount = (Number(data.saledata.price) * copies * 0.07).toFixed(5);
        const dt = discount ? true : false;
        const dtnftowner = data?.saledata?.discountnft || false;


        const digitalData = {
          buyamount: copies.toString(),
          owner: data?.saledata?.owneraddress,
          salePrice: data?.saledata?.price,
          tokenId: data?.saledata?.tokenId,
          dt: dt,
          dtamount: dt ? discountAmount : 0,
          dtnftowner: dtnftowner,
          dtnftowneramount: dtnftowner ? discountAmount : 0,
        };

        setBidProgress(true);

        try {
          const res = await web3Interaction.buyNFT(wallAddress, digitalData);
          if (res.status) {
            const bidprice = Number(data?.saledata?.price) * copies;

            const dataTransaction = {
              minted: 1,
              no_of_copies: copies,
              trans_hash: res.trans_Hash,
              sellitem_id: data?.saledata?.sell_id,
              from: data?.saledata?.owneraddress,
              to: wallAddress,
              creator_address: data?.saledata?.owneraddress,
              user_id: user?._id,
              nft_id: data?.saledata?.nftid,
              sale_type: "buy",
              buyer_id: user?._id,
              buyer_wallet: wallAddress,
              price: data?.saledata?.price,
              bid_price: bidprice,
              seller_disccounted: dt,
              seller_disccount_amount: dt ? discountAmount : 0,
              buyer_discounted: dtnftowner,
              buyer_discount_amount: dtnftowner ? discountAmount : 0,
              sale_event: "Fixed",
              seller_id: data?.saledata?.selleruser_id,
              discount1: discount,
              copies: copies,
              discount: data?.saledata?.discountnft,
              discounted_price: discountAmount,
            };

            // const transactionCallback = (res) => {
            //                   let data = {}
            //                   data.sender = process.env.REACT_APP_ADMIN_ID
            //                   data.receiver = props.ownerId
            //                   data.is_read = false
            //                   data.type = "sold"
            //                   data.sellItemId = sellItemId
            //                   data.content = `Congratulations! Someone has purchased your NFT. Your artwork is making waves. Check your account for details`
            //                   const notificaationCallback = (res) => {
            //                     if (user?._id) {
            //                       let notificationData = {}
            //                       notificationData.receiver = user?._id
            //                       dispatch(getArtNotificationsRequest(notificationData))
            //                     }
            //                   }
            //                   dispatch(postNotificationRequest(data, notificaationCallback));

            //                 }
            //   dispatch(addTransaction(dataTransaction, transactionCallback));

            if (Number(copies) === Number(data?.saledata?.avalable)) {
              const updateData = {
                _id: data?.saledata?.sell_id,
                available_copies: 0,
                status: false,
                sale_status: "sold",
                collection_update: true,
                collection_id: data?.saledata?.collection_id,
                copies: copies,
                user_id: user?._id,
                discount1: discount,
                discounted_price: discountAmount,
                price: data?.saledata?.price,
                print_amount: printInfo?.print_charge || 0,
              };
              dispatch(updateSellItem(updateData));
            } else {
              const availableCopies = Number(data.saledata.avalable) - Number(copies);
              const updateData = {
                _id: data?.saledata?.sell_id,
                available_copies: availableCopies,
                collection_update: true,
                collection_id: data?.saledata?.collection_id,
                copies: copies,
                user_id: user?._id,
              };
              dispatch(updateSellItem(updateData));
            }
            await handleDigitalPurchase(web3Interaction);
            toastr.success(`You have successfully bought ${copies} Digital Artwork copies of ${data?.saledata?.nftname}`);
          } else {
            toastr.error("Something went wrong during the Digital Artwork purchase.");
            hasError = true;
          }
        } catch (err) {
          toastr.error(err.message || "An error occurred.");
          hasError = true;
        }
      }
    } catch (err) {
      toastr.error(err.message || "An unexpected error occurred.");
      hasError = true;
    } finally {
      CloseDialog();
      setBidProgress(false);

      // Only navigate if no error occurred
      if (!hasError) {
        if (buyType === "Physical") {
          navigate("/profile/printrequest");
        } else if (buyType === "Digital") {
          navigate("/profile/ownedNft");
        }
      }
    }
  };

const cardBuy = async () => {
        let hasError = false; 
        let calamount_cal = 0;

        if (Number(ownerPriceMatic) > 0) {
          calamount_cal = Number(printInfo?.total_cost_matic) - Number(ownerPriceMatic);
        }
        // const physicalData = {
        //   owner: data?.saledata?.owneraddress,
        //   totalAmount: Number(Number(printInfo?.total_cost_matic).toFixed(5)),
        //   physicalOwnerAmount: Number(Number(ownerPriceMatic).toFixed(5)),
        //   calamount: Number(calamount_cal.toFixed(5))

        // };

        setBidProgress(true);

        try {
          
         const printRequestData = {
              ...printInfo,
              admin_earning: calPercentAmt(adminPercent, printInfo?.printer_alone_charge),
              printer_earning: printInfo?.printer_alone_charge,
              seller_earning: calPercentAmt(artistPercent, printInfo?.printer_alone_charge),
              order_received_date: formatDate(new Date()),
              due_date: formatDateAddDays(new Date()),
              owner_id: props.ownerId
            };

            dispatch(addPrintRequest(printRequestData, addPrintCallback));
            toastr.success("Print request added successfully");
        
        } catch (err) {
          console.log("thisistheerrror", err)
          toastr.error(err.message || "An error occurred.");
          hasError = true;
        }  finally {
      CloseDialog();
      setBidProgress(false);

      // Only navigate if no error occurred
      if (!hasError) {
        if (buyType === "Physical") {
          navigate("/profile/printrequest");
        } 
      }
    }
      
}


  // start Digital+Physical
  const sellNFTDP = async () => {
    let hasError = false;
    try {
      if (buyType !== "Digital+Physical") return;

      const web3Interaction = new Web3Intraction("polygon", hooks?.walletType, settings);

      const isValidNetwork = await validateNetworkService(web3Interaction);

      if (!isValidNetwork) return;

      const isMatic = await checkMaticNetwork(web3Interaction);

      if (!isMatic) return;
      let calamount_cal = 0;
      if (Number(ownerPriceMatic) > 0) {
        calamount_cal = Number(printInfo?.total_cost_matic) - Number(ownerPriceMatic);
      }
      const physicalNFTData = {
        owner: data?.saledata?.owneraddress,
        totalAmount: Number(Number(printInfo?.total_cost_matic).toFixed(4)),
        physicalOwnerAmount: Number(Number(ownerPriceMatic).toFixed(6)),
        calamount: Number(calamount_cal.toFixed(6))
      };

      setBidProgress(true);

      const receipt = await web3Interaction.buyPhysicalNFT(wallAddress, physicalNFTData);

      if (receipt?.status) {
        await handleDigitalPurchase(web3Interaction);
        processPrintRequest(printInfo);
        toastr.success(`You have successfully bought ${copies} Digital Artwork copies of ${data?.saledata?.nftname}`);
      } else {
        throw new Error("Artwork purchase failed");
      }
    } catch (err) {
      hasError = true;
     
      toastr.error(err.message || "Something went wrong.");

    } finally {
      setBidProgress(false);
      CloseDialog();
      setSellnftFunc(false);
      if (!hasError) {
        navigate('/profile/printrequest');
      }
    }
  };

  const validateNetworkService = async (web3Interaction) => {
    if (!web3Interaction.isNetworkServiceWorking()) {
      toastr.error("Service Not Available!");
      return false;
    }
    return true;
  };

  const checkMaticNetwork = async (web3Interaction) => {
    const isMatic = await web3Interaction.ismatic();
    setMaticmainnet(!isMatic);
    return isMatic;
  };

  const handleDigitalPurchase = async (web3Interaction) => {
    const discountAmount = calculateDiscount();
    const nftData = prepareNFTData(discountAmount);

    const digitalReceipt = await web3Interaction.buyNFT(wallAddress, nftData);
    if (!digitalReceipt?.status) throw new Error("Digital Artwork purchase failed");

    processTransaction(digitalReceipt);
    updateSellItemData();
    addOwnerData();
  };

  const calculateDiscount = () => {
    return (Number(data.saledata.price) * copies * 0.07).toFixed(6);
  };

  const prepareNFTData = (discountAmount) => {
    const isDiscounted = Boolean(discount);
    const isNFTDiscounted = Boolean(data?.saledata?.discountnft);

    return {
      buyamount: copies.toString(),
      owner: data?.saledata?.owneraddress,
      salePrice: data?.saledata?.price,
      tokenId: data?.saledata?.tokenId,
      dt: isDiscounted,
      dtamount: isDiscounted ? discountAmount : 0,
      dtnftowner: isNFTDiscounted,
      dtnftowneramount: isNFTDiscounted ? discountAmount : 0,
    };
  };
  const transactionCallbackdp = (res) => {
    let data = {}
    data.sender = process.env.REACT_APP_ADMIN_ID
    data.receiver = props.ownerId
    data.is_read = false
    data.type = "sold"
    data.sellItemId = sellItemId
    data.content = `Congratulations! Someone has purchased your Digital Artworks. Your artwork is making waves. Check your account for details`
    const notificaationCallback = (res) => {
      if (user?._id) {
        let notificationData = {}
        notificationData.receiver = user?._id
        dispatch(getArtNotificationsRequest(notificationData))
      }
    }
    dispatch(postNotificationRequest(data, notificaationCallback));

  }

  const processTransaction = (receipt) => {
    const transactionData = {
      minted: 1,
      no_of_copies: copies,
      trans_hash: receipt.trans_Hash,
      sellitem_id: data?.saledata?.sell_id,
      from: data?.saledata?.owneraddress,
      to: wallAddress,
      creator_address: data?.saledata?.owneraddress,
      user_id: user?._id,
      nft_id: data?.saledata?.nftid,
      sale_type: "buy",
      buyer_id: user?._id,
      buyer_wallet: wallAddress,
      price: data?.saledata?.price,
      bid_price: Number(data?.saledata?.price) * copies,
      seller_disccounted: discount,
      seller_disccount_amount: discount ? calculateDiscount() : 0,
      buyer_discounted: data?.saledata?.discountnft,
      buyer_discount_amount: data?.saledata?.discountnft ? calculateDiscount() : 0,
      sale_event: "Fixed",
      seller_id: data?.saledata?.selleruser_id,
      discount1: discount,
      copies: copies,
      discount: data?.saledata?.discountnft,
      discounted_price: calculateDiscount(),
    };
    dispatch(addTransaction(transactionData), transactionCallbackdp);
  };
  const updateSellItemData = () => {
    const updatedCopies = Number(data.saledata.avalable) - Number(copies);
    if (updatedCopies == 0) {
      const sellItemData = {
        _id: data?.saledata?.sell_id,
        available_copies: 0,
        status: false,
        sale_status: "sold",
        collection_update: true,
        collection_id: data?.saledata?.collection_id,
        copies: copies,
        user_id: user?._id,
        discount1: discount,
        discounted_price: discount ? calculateDiscount() : 0,
        price: data?.saledata?.price,
        print_amount: printInfo?.print_charge || 0
      };
      dispatch(updateSellItem(sellItemData));
    } else if (updatedCopies > 0) {
      const sellItemData = {
        _id: data?.saledata?.sell_id,
        available_copies: updatedCopies,
        collection_update: true,
        collection_id: data?.saledata?.collection_id,
        copies: copies,
        user_id: user?._id,
        discount1: discount,
        discounted_price: discount ? calculateDiscount() : 0,
        price: data?.saledata?.price,
        print_amount: printInfo?.print_charge || 0
      };
      dispatch(updateSellItem(sellItemData));

    }

  };
  const addOwnerData = () => {
    const ownerData = {
      nft_id: data?.saledata?.nftid,
      owner_id: data?.saledata?.userid,
      total_copies: copies,
      price: data?.saledata?.price,
      available_copies: copies,
      creator: data?.saledata?.creator_id,
      buy_from: data?.saledata?.owneraddress,
      status: true,
      owner_wallet: wallAddress,
      loyality: data?.saledata?.royalties,
      onSale: false,
      ownership_status: "Completed",
      owner_type: true,
      sellItem_id: data?.saledata?.sell_id,
    };
    dispatch(addParticularOwner(ownerData));
  };
  const addPrintCallbackdp = (res) => {
    if (res.status === "success") {
      let printTransData = {};
      printTransData.print_request_id = res.data._id
      printTransData.admin_earning = calPercentAmt(adminPercent, printInfo?.print_charge)
      printTransData.seller_earning = calPercentAmt(artistPercent, printInfo?.print_charge)
      printTransData.printer_earning = calPercentAmt(printerPercent, printInfo?.print_charge)
      printTransData.total_amount = Number(printInfo?.print_charge) + Number(data.saledata?.premium_print_cost || 0)
      printTransData.premium_amount = data.saledata?.premium_print_cost
      printTransData.payment_status = "Completed"
      printTransData.status = "Completed"
      printTransData.nft_id = data?.saledata?.nftid
      printTransData.from = data?.saledata?.owneraddress
      printTransData.to = wallAddress
      printTransData.user_id = user?._id
      printTransData.seller_id = props.ownerId
      printTransData.buyer_id = user?._id
      dispatch(addPrintTranasction(printTransData))
      toastr.success("Print request added successfully")

    } else {
      toastr.error("Error in Print Request")
    }
  }

  const processPrintRequest = (printInfo) => {
    const printData = {
      ...printInfo,
      admin_earning: calPercentAmt(adminPercent, printInfo?.printer_alone_charge),
      printer_earning: printInfo?.printer_alone_charge,
      seller_earning: calPercentAmt(artistPercent, printInfo?.printer_alone_charge),
      order_received_date: formatDate(new Date()),
      due_date: formatDateAddDays(new Date()),
      owner_id: props.ownerId
    };
    dispatch(addPrintRequest(printData), addPrintCallbackdp);
  };

  const buyNFT = async () => {
    console.log("called1")
    const showError = (message) => toastr.error(message);
    const isAgreementChecked = () => document.getElementById('Agreement')?.checked || checekdValue;

    const validateCopies = () => {
      const availableCopies = Number(data.saledata.avalable);
      const requestedCopies = Number(copies);

      if (requestedCopies > availableCopies) {
        showError("Please input the available number of copies.");
        return false;
      }
      if (requestedCopies < 1) {
        showError("Please input the number of copies within the available Digital Artwork limit.");
        return false;
      }
      return true;
    };
  

    if (buyType === "Physical") {
      if (!checekdValue) return showError("Please check the Digital Artwork Purchase & IP License Agreement")
      // await sellnft();
    await cardBuy();

    } else if (buyType === "Digital" || buyType === "Digital+Physical") {
      if (!validateCopies()) return;

      if (!isAgreementChecked()) {
        return showError("Please check the Digital Artwork Purchase & IP License Agreement");
      }
      console.log("called2")
      if (buyType === "Digital") {
        console.log("called2")
        await sellnft();

      } else {
        await sellNFTDP();
      }
    }
  };
  const [serviceAgree, setserviceAgree] = useState(false);
  function serviceag() {
    setserviceAgree(true)
  }
  function closeTerms() {
    setCheckedValue(false)
    setserviceAgree(false)

  }
  function handleAgreevalue(e) {

    setCheckedValue(!checekdValue)
  }
  const discountchange = () => {
    if (discount) {
      setDiscount(false)
    } else {
      setDiscount(true)
    }
  }

  useEffect(()=>{console.log("printInfo", printInfo, "usdPrice" , usdPrice,"copies", copies)},[printInfo])
  return (
    <>
      <Modal
        className="termandCoDialog"
        show={serviceAgree}
        centered
        animation={false}
      >

        <div className="contentBoxdialog">
          <NFTPurchasecenter />
          <button
            className="btn btn-primary px-5 btn-sm py-2"
            onClick={closeTerms}
          >
            Back
          </button>
        </div>

      </Modal>
      {bidProgress == true ? (
        <div className="processingDialog">
          <h1>
            <i className="fa-duotone fa-loader"></i>
          </h1>
          <h1>Processing</h1>
          <p> Metamask processing....</p>
        </div>
      ) : (
        <>
          <div className="dialogHeader px-3">
            <h3>{buyType === "Physical" ? "Purchase Physical Edition" : (buyType === "Digital" ? "Buy Artworks" : "Purchase Digital + Physical Edition")}</h3>
            <button onClick={CloseDialog}>
              <i className="fa-regular fa-xmark"></i>
            </button>
          </div>
          <div className="buyNowBox">
            <div className="nftnameBox">
              <div className="nftname">
                <div className="nftImg">
                  <img src={data.saledata.url} className="img-fluid" alt="" />
                </div>
                <>{(data?.saledata?.nftname).length > 15 ? <h3>{(data?.saledata?.nftname)?.substring(0, 10) + "....."}</h3> : <h3>{data?.saledata?.nftname}</h3>}</>
              </div>
              <div className="nftprice">
                <h3 className="d-flex align-items-center gap-2">
                  {data.saledata.price}{" "}
                  <img
                    src="/images/svg/maticIcon.svg"
                    className="img-fluid"
                    width={20}
                    alt=""
                  />{" "}
                </h3>

              </div>
            </div>
          </div>
          <div className="buyNowBox">
            <div className="nftnameBox">
              <div className="nftname">
                <div className="nftImg maticIconm">
                  <img
                    src="/images/svg/maticIcon.svg"
                    className="img-fluid"
                    alt=""
                  />
                </div>
                <div>
                  {wallAddress && wallAddress != "undefined" ? (
                    <>
                      <h3>
                        {wallAddress?.substring(0, 7) +
                          "......" +
                          wallAddress?.substring(32)}
                      </h3>
                    </>
                  ) : (
                    <h3>*******</h3>
                  )}
                  <p>POL</p>
                </div>
              </div>
              <div className="nftprice">
                {wallAddress && wallAddress != "undefined" ? (
                  <button className="connected">Connected</button>
                ) : (
                  <button className="connected">Not Connected</button>
                )}
              </div>
            </div>
          </div>
          <div className="buyNowBox">
            {(buyType === "Physical" || buyType === "Digital+Physical") &&
              <div className="nftnameBox border-0  px-0 rounded-0">
                <h3>Print Cost</h3>

                <h3>
                  {(printInfo?.print_charge / usdPrice?.data).toFixed(6)} POL $({Number(printInfo?.print_charge).toFixed(6)})
                </h3>
              </div>
            }
            {(buyType === "Physical" || buyType === "Digital+Physical") &&
              <div className="nftnameBox border-0  px-0 rounded-0">
                <h3>Premium Cost</h3>

                <h3>
                  {Number(data.saledata?.premium_print_cost ? data.saledata?.premium_print_cost : 0).toFixed(6) || 0} POL $(
                  {((Number(data.saledata?.premium_print_cost ? data.saledata?.premium_print_cost : 0) * usdPrice?.data) || 0).toFixed(6)})
                </h3>
              </div>
            }
            {(buyType === "Physical" || buyType === "Digital+Physical") &&
              <div className="nftnameBox border-0  px-0 rounded-0">
                <h3>tax</h3>

                <h3>
                  {Number(taxPercent).toFixed(6) || Number(0)} POL $(
                  {((Number(taxPercent).toFixed(6) * Number(usdPrice?.data).toFixed(6)) || 0).toFixed(6)})
                </h3>
              </div>
            }


            {(buyType === "Digital+Physical" || buyType === "Digital") &&
              <>
                <div className="nftnameBox border-0  px-0 rounded-0">
                  <h3>Price</h3>

                  <h3>
                    {Number(data.saledata.price).toFixed(6)} POL $(
                    {(data.saledata.price * usdPrice?.data).toFixed(6)})
                  </h3>
                </div>
                {(buyType === "Digital+Physical" || buyType === "Digital") &&
                  <div className="nftnameBox border-0  px-0 rounded-0">
                    <h3>Edition Size</h3>
                    <h3>{data.saledata.copies}</h3>
                  </div>}
                {(buyType === "Digital+Physical" || buyType === "Digital") &&
                  <div className="nftnameBox border-0  px-0 rounded-0">
                    <h3>Available Digital Artworks</h3>
                    <h3>{data.saledata.avalable}</h3>
                  </div>
                }

                <div className="nftnameBox  border-0  px-0 rounded-0 ">
                  <h3>Buy Digital Artworks</h3>
                  <h3>
                    <input
                      type="number" id="nft-number"
                      className="form-control text-end"
                      step={1}
                      onChange={(e) => getcopies(e)}
                      onInput={(e) => {
                        e.target.value = Math.floor(Math.abs(e.target.value));
                        if (e.target.value > Number(data?.saledata?.avalable)) {
                          e.target.value = Number(data?.saledata?.avalable);
                        }
                      }}
                    />
                  </h3>
                </div> </>
            }
            <div className="buyNowBox border-0 border-bottom border-dark  px-0 rounded-0">
              {checkdiscount ? (<><div className="CustomeCheckBox">
                <Input type="checkbox" id="useDiscount" onChange={discountchange} />
                <label className="cursor-pointer" htmlFor="useDiscount"></label>
                <div className=" text-start">
                  <span className=" text-black">
                    You are eligible for Referral Discount, do you want use it in this purchase?
                  </span>
                </div>
              </div></>) : ""}
            </div>
            {checkdiscount && discount && (buyType === "Physical" || buyType === "Digital+Physical") ? (
              <>
                <div className="nftnameBox px-0 border-0">
                  <h3>amount</h3>
                  <h3>
                    {(Number(data.saledata.price) * copies).toFixed(6)} POL
                  </h3>
                </div>
                <div className="nftnameBox px-0 border-0 pt-0 ">
                  <h3>Discount</h3>
                  <h3> {(Number(data.saledata.price) * copies * 0.07).toFixed(6)} POL</h3>
                </div>

                <div className="nftnameBox px-0 border-0 pt-0">
                  <h3>You will pay</h3>
                  {buyType === "Digital" &&
                    <h3>

                      $({(
                        (Number(data.saledata.price) *
                          copies - (Number(data.saledata.price) * copies * 0.07)) *
                        usdPrice?.data
                      ).toFixed(6)}
                      ) {((Number(data.saledata.price) * copies) - (Number(data.saledata.price) * copies * 0.07)).toFixed(6)} POL
                    </h3>}
                  {(buyType === "Digital+Physical") &&
                    <h3>
                      $({(Number(printInfo?.print_charge) + (Number(data.saledata.price) * copies * usdPrice?.data) - (Number(data.saledata.price) * copies * usdPrice?.data * 0.07)).toFixed(6)})
                      {(((Number(data.saledata.price) * copies) - (Number(data.saledata.price) * copies * 0.07)) + totalPrice * usdPrice?.data).toFixed(6) + (Number(printInfo?.print_charge) / usdPrice?.data) + (data.saledata?.premium_print_cost || 0)} POL
                    </h3>}
                  {(buyType === "Physical") &&
                    <h3>
                      $({
                        (totalPrice * usdPrice?.data)
                          .toFixed(6)}
                      ) {(((Number(data.saledata.price) * copies) - (Number(data.saledata.price) * copies * 0.07)) + totalPrice * usdPrice?.data).toFixed(6)} POL
                    </h3>}
                </div>
              </>) : <>
              <div className="nftnameBox px-0 border-0">
                <h3>You will pay</h3>
                {buyType === "Digital" &&
                  <h3>

                    $(
                    {((Number(data.saledata.price) * copies) * usdPrice?.data).toFixed(6)})
                    {(Number(data.saledata.price) * copies).toFixed(6)} POL
                  </h3>
                }
                {buyType === "Digital+Physical" &&
                  <h3>
                    {/* {((Number(data.saledata.price) * copies) + Number(totalPrice) * usdPrice?.data).toFixed(6)} MATIC $({(((Number(data.saledata.price) * copies)) * usdPrice?.data + Number(totalPrice)).toFixed(6)}) */}
                    $({(Number(printInfo?.print_charge) + (Number(data.saledata.price) * copies * usdPrice?.data)).toFixed(6)})
                    {Number((printInfo?.print_charge / usdPrice?.data) + (Number(data.saledata.price) * copies)).toFixed(6)} POL
                  </h3>}
                {buyType === "Physical" &&
                  <h3>
                       {(Number(totalPrice)).toFixed(6)} POL
                    $({(Number(totalPrice) * usdPrice?.data).toFixed(6)})
                 
                  </h3>}
              </div>
            </>}

          </div>
          <div className="buyNowBox">
            <div className="CustomeCheckBox">
              <Input type="checkbox" id="Agreement" onClick={(e) => handleAgreevalue(e)} checked={checekdValue} />
              <label className="cursor-pointer" htmlFor="Agreement"></label>
              <div>
                <span className=" text-black">
                  I agree to{" "}
                  <span
                    onClick={serviceag}
                    className="link_text mb-0 cursor-pointer"
                  >
                    {" "}
                    Digital Artwork Purchase & IP License Agreement
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div className="buyNowBox">
            {(wallAddress && wallAddress != "undefined") || (buyType === "Physical") ? (
              <button
                className="btn btn-secondary text-white py-3 w-100"
                onClick={buyNFT}
              >
              {(buyType === "Physical")? "Pay Now": "Buy Now"}  
              </button>
            ) : (
              <Link
                to={"/metamask-sign"}
                className="btn btn-danger text-white py-3 w-100"
              >
                Please Connect Metamask
              </Link>
            )}
          </div>
          <p className="text-danger d-flex align-items-center justify-content-center gap-2 ">
            {maticmainnet ? (
              <>
                {" "}
                Please switch to Matic (Polygon) network{" "}
                <Link
                  className="text-decoration-none text-danger"
                  to={
                    "https://www.coindesk.com/learn/how-to-connect-metamask-to-the-polygon-network/"
                  }
                  target={"_blank"}
                >
                  <sup>
                    <i class="fa-solid fa-circle-info"></i>
                  </sup>
                </Link>{" "}
              </>
            ) : (
              ""
            )}
          </p>
        </>
      )}
    </>
  );
})


function calPercentAmt(percentage = 25, amount = 100) {
  return ((percentage / 100) * amount).toFixed(6)
}